import { userIntance } from '../../shared/axios';
import { AccountRegistrationStatus } from './types';

export const getRegistrationStatus = async (email: string) => {
  const { data } = await userIntance.get<AccountRegistrationStatus>(
    `/accounts/${email}/status`
  );
  return data;
};
